import { call, put, takeEvery } from 'redux-saga/effects'
import {
    GET_JOB_OFFER_ALERTS,
    DELETE_JOB_OFFER_ALERT,
    TOGGLE_JOB_OFFER_ALERT,
    CREATE_JOB_OFFER_ALERT
} from '../action-types'
import {
    getJobOfferAlerts,
    deleteJobOfferAlert,
    toggleJobOfferAlert,
    createJobOfferAlert
} from '../api/Alert'
import {
    getJobOfferAlertsSuccess,
    deleteJobOfferAlertSuccess,
    toggleJobOfferAlertSuccess,
    createJobOfferAlertSuccess
} from '../actions/Alert'
import { fetchError, fetchExpired, fetchStart, fetchSuccess } from '../actions/Common'
import { toast } from 'react-toastify'

function* getAlerts({ token }) {
    try {
        yield put(fetchStart())
        const response = yield call(getJobOfferAlerts, token)
        if (response.status === 200) {
            yield put(getJobOfferAlertsSuccess(response.data))
            yield put(fetchSuccess())
        }
        if (response.status === 401) {
            yield put(fetchExpired())
        }
        if (response.status === 500) {
            yield put(fetchError(response.data))
        }
    } catch (error) {
        console.error('Error fetching alerts:', error)
        yield put(fetchError(error))
    }
}

function* deleteAlert({ token, alertId, intl }) {
    try {
        yield put(fetchStart())
        const response = yield call(deleteJobOfferAlert, token, alertId)
        if (response?.status === 204 || response?.status === 200) {
            yield put(deleteJobOfferAlertSuccess(alertId))
            yield put(fetchSuccess())
            toast.success(intl.formatMessage({ id: "alertDeletedSuccess" }))
        } else {
            yield put(fetchError(response.data))
            toast.error(intl.formatMessage({ id: "global_error_alert" }))
        }
    } catch (error) {
        console.error('Error deleting alert:', error)
        yield put(fetchError(error))
        toast.error(intl.formatMessage({ id: "global_error_alert" }))
    }
}

function* toggleAlert({ token, alertId, intl }) {
    try {
        yield put(fetchStart())
        const response = yield call(toggleJobOfferAlert, token, alertId)
        if (response?.status === 200 || response?.status === 204) {
            yield put(toggleJobOfferAlertSuccess(alertId))
            yield put(fetchSuccess())
            toast.success(intl.formatMessage({ id: "alertUpdatedSuccess" }))
        } else {
            yield put(fetchError(response.data))
            toast.error(intl.formatMessage({ id: "global_error_alert" }))
        }
    } catch (error) {
        console.error('Error toggling alert:', error)
        yield put(fetchError(error))
        toast.error(intl.formatMessage({ id: "global_error_alert" }))
    }
}

function* createAlert({ token, data, intl }) {
    try {
        yield put(fetchStart())
        const response = yield call(createJobOfferAlert, token, data)
        
        // If response has errors property, it's an error response
        if (response?.errors) {
            yield put(fetchError(response))
            toast.error(intl.formatMessage({ id: "alertCreationError" }))
            return
        }

        // If response has id and other alert properties, it's a success
        if (response?.id && response?.filters) {
            // Fetch the full list after successful creation
            const alertsResponse = yield call(getJobOfferAlerts, token)
            if (alertsResponse.status === 200) {
                yield put(getJobOfferAlertsSuccess(alertsResponse.data))
                yield put(fetchSuccess())
                toast.success(intl.formatMessage({ id: "alertCreatedSuccess" }))
            } else {
                yield put(fetchError(alertsResponse.data))
                toast.error(intl.formatMessage({ id: "global_error_alert" }))
            }
            return
        }

        // Handle unexpected response format
        yield put(fetchError(response))
        toast.error(intl.formatMessage({ id: "global_error_alert" }))
    } catch (error) {
        console.error('Error creating alert:', error)
        yield put(fetchError(error))
        toast.error(intl.formatMessage({ id: "global_error_alert" }))
    }
}

export default function* alertSaga() {
    yield takeEvery(GET_JOB_OFFER_ALERTS, getAlerts)
    yield takeEvery(DELETE_JOB_OFFER_ALERT, deleteAlert)
    yield takeEvery(TOGGLE_JOB_OFFER_ALERT, toggleAlert)
    yield takeEvery(CREATE_JOB_OFFER_ALERT, createAlert)
}
